import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { ActionIconButton } from 'framework/ui/ui-builder';
import { FilterBar, PageContentProcessTabs } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import { Timeline } from 'framework/ViewTypes/embeddable';
import type { TimelineConfig, TimelineItem, TimelineSourceRecord } from 'framework/ViewTypes/embeddable';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

type PlaceholderTimelineItem = TimelineItem<'PLACEHOLDER'> & TimelineSourceRecord<'PLACEHOLDER'>;

const timelineConfig: TimelineConfig<PlaceholderTimelineItem> = {
  RecordAuthor: TimelineRecordAuthorWithAccessCheck,
  types: { PLACEHOLDER: {} },
};

const PositionSlotProcessTabs = ({ canCreateTimelineEntry }: { canCreateTimelineEntry: boolean }) => {
  // TODO: replace this placeholder when position lifecycle timeline endpoints are implemented.
  const items: PlaceholderTimelineItem[] = [];

  return (
    <PageContentProcessTabs
      tabs={[
        {
          id: 'timeline',
          name: 'Timeline',
          panel: <Timeline items={items} config={timelineConfig} emptyStateText="No activity yet." />,
        },
      ]}
      actions={[
        <FilterBar
          key="filter"
          filterProps={{
            value: {},
            onChange: () => undefined,
            filters: [
              {
                id: 'activityType',
                source: 'activityType',
                condition: FilterCondition.IN,
                type: 'dropdown',
                label: 'Activity type',
                multiple: true,
                options: [],
              },
            ],
          }}
        />,
        <ActionIconButton
          icon={<EditNoteOutlinedIcon />}
          onClick={() => {}}
          // TODO Update this condition when the timeline note creation feature is available
          disabled={true || !canCreateTimelineEntry}
          key="add"
          label="Add note"
          tooltip="Add note"
          variant="outlined"
        />,
      ]}
    />
  );
};

export default PositionSlotProcessTabs;
